export const LHCOverruleReasons = Object.freeze({
  CITIZEN: 'OSE',
  MIGRANT: 'IMM',
  EX_ADF: 'ADF',
  HELD_PHI_31_YO: 'YEA',
  CURRENT_HOSPITAL_COVER: 'ERR',
  NONE: 'NONE',
});
